const internationalization = {
  "locales": [
    "en",
    "ja"
  ],
  "requiredLocales": [
    "en",
    "ja"
  ],
  "strictMode": "inclusive",
  "defaultLocale": "ja"
};
const dictionary = {
  "fill": true,
  "contentAutoTransformation": false,
  "location": "local",
  "importMode": "static"
};
const routing = {
  "mode": "no-prefix",
  "enableProxy": false,
  "storage": {
    "localStorage": [
      {
        "name": "INTLAYER_LOCALE"
      }
    ]
  },
  "basePath": ""
};
const content = {
  "fileExtensions": [
    ".content.ts",
    ".content.js",
    ".content.cjs",
    ".content.mjs",
    ".content.json",
    ".content.json5",
    ".content.jsonc",
    ".content.tsx",
    ".content.jsx",
    ".content.md",
    ".content.mdx",
    ".content.yaml",
    ".content.yml"
  ],
  "contentDir": [
    "/opt/actions-runner/work/runner-3/web/web"
  ],
  "codeDir": [
    "/opt/actions-runner/work/runner-3/web/web"
  ],
  "excludedPath": [
    "**/node_modules/**",
    "**/dist/**",
    "**/build/**",
    "**/.intlayer/**",
    "**/.next/**",
    "**/.nuxt/**",
    "**/.expo/**",
    "**/.vercel/**",
    "**/.turbo/**",
    "**/.tanstack/**",
    "**/.output/**",
    "**/.svelte-kit/**"
  ],
  "watch": true
};
const system = {
  "baseDir": "/opt/actions-runner/work/runner-3/web/web",
  "moduleAugmentationDir": "/opt/actions-runner/work/runner-3/web/web/.intlayer/types",
  "unmergedDictionariesDir": "/opt/actions-runner/work/runner-3/web/web/.intlayer/unmerged_dictionary",
  "remoteDictionariesDir": "/opt/actions-runner/work/runner-3/web/web/.intlayer/remote_dictionary",
  "dictionariesDir": "/opt/actions-runner/work/runner-3/web/web/.intlayer/dictionary",
  "dynamicDictionariesDir": "/opt/actions-runner/work/runner-3/web/web/.intlayer/dynamic_dictionary",
  "fetchDictionariesDir": "/opt/actions-runner/work/runner-3/web/web/.intlayer/fetch_dictionary",
  "typesDir": "/opt/actions-runner/work/runner-3/web/web/.intlayer/types",
  "mainDir": "/opt/actions-runner/work/runner-3/web/web/.intlayer/main",
  "configDir": "/opt/actions-runner/work/runner-3/web/web/.intlayer/config",
  "cacheDir": "/opt/actions-runner/work/runner-3/web/web/.intlayer/cache",
  "tempDir": "/opt/actions-runner/work/runner-3/web/web/.intlayer/tmp"
};
const editor = {
  "editorURL": "http://localhost:8000",
  "cmsURL": "https://app.intlayer.org",
  "backendURL": "https://back.intlayer.org",
  "port": 8000,
  "enabled": false,
  "dictionaryPriorityStrategy": "local_first",
  "liveSync": false,
  "liveSyncPort": 4000,
  "liveSyncURL": "http://localhost:4000"
};
const analytics = {
  "enabled": true,
  "flushInterval": 20000,
  "sampleRate": 1
};
const log = {
  "mode": "default",
  "prefix": "\u001b[38;5;239m[intlayer] \u001b[0m"
};
const ai = {};
const build = {
  "mode": "auto",
  "minify": false,
  "purge": false,
  "chunkGrouping": true,
  "dictionariesPreload": true,
  "traversePattern": [
    "**/*.{tsx,ts,js,mjs,cjs,jsx,vue,svelte,astro}",
    "!**/node_modules/**",
    "!**/dist/**",
    "!**/build/**",
    "!**/.intlayer/**",
    "!**/.next/**",
    "!**/.nuxt/**",
    "!**/.expo/**",
    "!**/.vercel/**",
    "!**/.turbo/**",
    "!**/.tanstack/**",
    "!**/.output/**",
    "!**/.svelte-kit/**",
    "!**/*.config.*",
    "!**/*.test.*",
    "!**/*.spec.*",
    "!**/*.stories.*",
    "!**/*.d.ts",
    "!**/*.d.ts.map",
    "!**/*.map"
  ],
  "outputFormat": [
    "esm",
    "cjs"
  ],
  "cache": true,
  "checkTypes": false
};
const compiler = {
  "enabled": false,
  "dictionaryKeyPrefix": "",
  "noMetadata": false,
  "saveComponents": false
};
const schemas = undefined;
const plugins = undefined;

export { internationalization, dictionary, routing, content, system, editor, analytics, log, ai, build, compiler, schemas, plugins };
